import { Injectable } from '@angular/core';
import { DroplistItem, PageTabsLayoutPageService } from '@eforall/dashboard';


/**
 * The list of tabs on this page
 */
export enum VolunteeringSpecialistsPageTabId {
	Specialists = 1,
	Tab1 = 2,
	Tab2 = 3,
}

/**
 * The list of main tab droplist views on this page
 */
export enum VolunteeringSpecialistsPageViewId {
	SpecialistPool = 1,
	SignUps = 2,
	SessionAssignments = 3,
	ApprovedSpecialistsByTopic = 4,
	NotApprovedSpecialistsByTopic = 5,
}


@Injectable({ providedIn: 'root' })
export class VolunteeringSpecialistsService extends PageTabsLayoutPageService<VolunteeringSpecialistsPageTabId, VolunteeringSpecialistsPageViewId> {


	private static readonly _viewDroplistItems1: DroplistItem<never, VolunteeringSpecialistsPageViewId>[] = [
		{
			uniqueId: VolunteeringSpecialistsPageViewId.SpecialistPool,
			iconContext: {
				iconClass: 'fa-grip-horizontal',
				iconStyle: 'fa-solid',
				text: 'Specialist Pool',
				hideText: 'never',
			},
		},
		{
			uniqueId: VolunteeringSpecialistsPageViewId.SignUps,
			iconContext: {
				iconClass: 'fa-grip-horizontal',
				iconStyle: 'fa-solid',
				text: 'Sign-ups',
				hideText: 'never',
			},
		},
		{
			uniqueId: VolunteeringSpecialistsPageViewId.SessionAssignments,
			iconContext: {
				iconClass: 'fa-grip-horizontal',
				iconStyle: 'fa-solid',
				text: 'Session Assignments',
				hideText: 'never',
			},
		},
		{
			uniqueId: VolunteeringSpecialistsPageViewId.ApprovedSpecialistsByTopic,
			iconContext: {
				iconClass: 'fa-grip-horizontal',
				iconStyle: 'fa-solid',
				text: 'Approved Specialists by Topic',
				hideText: 'never',
			},
		},
		{
			uniqueId: VolunteeringSpecialistsPageViewId.NotApprovedSpecialistsByTopic,
			iconContext: {
				iconClass: 'fa-grip-horizontal',
				iconStyle: 'fa-solid',
				text: 'Not Approved Specialists by Topic',
				hideText: 'never',
			},
		},
	];

	constructor() {
		super(VolunteeringSpecialistsService._viewDroplistItems1, VolunteeringSpecialistsService.name, VolunteeringSpecialistsPageTabId.Specialists, VolunteeringSpecialistsPageViewId.SignUps);
	}

	public get viewId() {
		return VolunteeringSpecialistsPageViewId;
	}
}